import { ThemedView } from "@/components/ThemedView";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/ui/form";
import { useLocale } from "@/hooks/locale";
import { useTheme } from "@/hooks/theme";
import type { UseFormReturn } from "react-hook-form";

export const FormOptions = (props: {
    label: string;
    form: UseFormReturn<any>;
    name: string;
    options: {
        label: string;
        value: any;
    }[];
}) => {
    const theme = useTheme();
    const { t } = useLocale();
    return (
        <FormField
            control={props.form.control}
            name={props.name}
            render={({ field }) => {
                return (
                    <>
                        <ThemedView
                            style={{
                                gap: "12px",
                            }}
                        >
                            <ThemedView
                                style={{
                                    fontWeight: "500",
                                    color: theme.colors.onSurface,
                                }}
                            >
                                {t(props.label)}
                            </ThemedView>
                            <ThemedView
                                style={{
                                    borderRadius: "12px",
                                    border: `solid 1px ${theme.colors.disabled}`,
                                    flexDirection: "row",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "16px",
                                    padding: "16px",
                                    justifyContent: "space-around",
                                    background: theme.colors.background,
                                }}
                            >
                                {props.options.map((option, index) => {
                                    const selected =
                                        field.value == option.value;
                                    return (
                                        <Button
                                            disabled={selected}
                                            onClick={() => {
                                                field.onChange(option.value);
                                            }}
                                            key={String(index)}
                                            variant={"outline"}
                                            style={{
                                                boxShadow: !selected
                                                    ? undefined
                                                    : "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                                background: !selected
                                                    ? theme.colors.surface
                                                    : theme.colors.primary,
                                                color: !selected
                                                    ? theme.colors.onSurface
                                                    : theme.colors.onPrimary,
                                            }}
                                        >
                                            {t(option.label)}
                                        </Button>
                                    );
                                })}
                            </ThemedView>
                        </ThemedView>
                    </>
                );
            }}
        ></FormField>
    );
};